import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/storage'
import './plugins/crypto'
import './plugins/numeric'
import './plugins/device'
import './plugins/cache'
import './plugins/scan'
import './plugins/firebase'
import i18n from './i18n'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

// Initialize trust store
store.dispatch('trust/init')
store.dispatch('bitcoin/init')
